import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarCoberturasRequest } from '../../models/cotizador-contratante/consultar-coberturas/request/consultar-coberturas-request.model';
import { ConsultarCoberturasResponse } from '../../models/cotizador-contratante/consultar-coberturas/response/consultar-coberturas-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarCoberturasService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.VALIDAR_COBERTURA}`;

  constructor(private httpClient: HttpClient) { }

  validarCobertura(request: ConsultarCoberturasRequest): Observable<ConsultarCoberturasResponse> {
    return this.httpClient.post<ConsultarCoberturasResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en validarCobertura: ', error);
        return throwError(() => new Error(error?.message || 'Error al validar cobertura'));
      })
    );
  }
}
